import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=912ff6ec&"
import script from "./text-editor.vue?vue&type=script&lang=ts&"
export * from "./text-editor.vue?vue&type=script&lang=ts&"
import style0 from "./text-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports